module.exports = __webpack_public_path__ + "media/images/bubble-img-01-bc1bf1e11dda14554c858303bd0e2c4c.svg";